import { UseCurrencyDecorator } from '../../../../../../../../utilities/hooks/UseCurrencyDecorator';
import PropTypes from 'prop-types';
import React from 'react';
import { AmountFormatHelper } from '../../../../../../../../utilities/helpers/AmountFormatHelper';

const InvoiceItem = ({ item, currency }) => {
	const currencyDecorator = UseCurrencyDecorator();

	return (
		<div
			className="participant-row-container"
			data-testid="customer-invoice-item"
			style={{ justifyContent: 'space-between', marginBottom: '24px' }}
		>
			<h4 style={{ fontWeight: 'normal' }} className='truncate participant-row-container-quty-rate' title={currencyDecorator(AmountFormatHelper.formatAmount(item.rate), currency) + ' x ' + item.quantity + ' ' + item.name}>
				{currencyDecorator(AmountFormatHelper.formatAmount(item.rate), currency) + ' x ' + item.quantity + ' ' + item.name}
			</h4>
			<h4 style={{ fontWeight: 'normal' }}>
				{currencyDecorator(item.quantity * AmountFormatHelper.formatAmount(item.rate), currency)}
			</h4>
		</div>
	);
};

InvoiceItem.propTypes = {
	item: PropTypes.object.isRequired,
	currency: PropTypes.object
};

export default InvoiceItem;
